import { Record } from 'immutable';

const stateRecord = Record({
    isLoading: false,
    fieldsData: []
});

export const initialState = stateRecord();